import { useMemo } from 'react'

import {Order, Patient} from 'store/types'
import moment from "moment/moment";
import {getGender} from "./generalHelper";

const warn = '#ff110030'
const patientFormCss = (patient: any, handler: 'LAMBDA' | 'SYNTHPOP') =>
  patient
    ? {
        'input[name="firstName"]': {
          backgroundColor: patient?.firstName ? 'none' : warn,
        },
        'input[name="middleName"]': {
          backgroundColor: handler === 'SYNTHPOP' && !patient?.middleName ? warn : 'none',
        },
        'input[name="lastName"]': {
          backgroundColor: patient?.lastName ? 'none' : warn,
        },
        'input[name="dob"]': {
          backgroundColor: patient?.dob ? 'none' : warn,
        },
        'select[name="gender"]': {
          backgroundColor: handler === 'SYNTHPOP' && !patient?.gender ? warn : 'none',
        },
        'input[name="homePhone"]': {
          backgroundColor: handler === 'SYNTHPOP' && !patient?.homePhone ? warn : 'none',
        },
        'input[id="address"]': {
          backgroundColor: !patient?.address?.data?.line1 ? warn : 'none',
        },
        'input[id="address2"]': {
          backgroundColor: !patient?.address?.data?.line2 ? warn : 'none',
        },
        'input[name="primaryAddressCity"]': {
          backgroundColor: !patient?.address?.data?.city ? warn : 'none',
        },
        'select[name="primaryAddressState"]': {
          backgroundColor: !patient?.address?.data?.state ? warn : 'none',
        },
        'input[name="primaryAddressZip"]': {
          backgroundColor: !patient?.address?.data?.zip ? warn : 'none',
        },
      }
    : {}

const normalizedName = (v: string | undefined) => (v ?? '').toLowerCase().trim()

const orderPatientFormCss = (aiPatientData: any, orderPatientData: Patient) =>
  aiPatientData
    ? {
      'input[name="firstName"]': {
        backgroundColor: normalizedName(aiPatientData.firstName) === normalizedName(orderPatientData.firstName) ? 'none' : warn,
      },
      'input[name="lastName"]': {
        backgroundColor: normalizedName(aiPatientData.lastName) === normalizedName(orderPatientData.lastName) ? 'none' : warn,
      },
      'input[name="dob"]': {
        backgroundColor: aiPatientData.dob === moment(orderPatientData.dob).format('MM/DD/YYYY') ? 'none' : warn,
      },
      'select[name="gender"]': {
        backgroundColor: aiPatientData.gender === (orderPatientData?.gender && getGender(orderPatientData.gender)) ? 'none' : warn,
      },
    }
    : {}

const getPatientData = (rxData: any) => {
  if (rxData?.demographics) {
    const synthpopPatientData = rxData.demographics
    return {
      firstName: synthpopPatientData?.first_name,
      lastName: synthpopPatientData?.last_name,
      dob: synthpopPatientData?.DOB && moment(synthpopPatientData.DOB).format('MM/DD/YYYY'),
      gender: synthpopPatientData?.gender && getGender(synthpopPatientData.gender),
    }
  }
  return {
    firstName: rxData?.patientFirstName,
    lastName: rxData?.patientLastName,
    dob: rxData?.patientDob && moment(rxData.patientDob).format('MM/DD/YYYY'),
    gender: rxData?.patientGender && getGender(rxData.patientGender),
  }
}

export const useRecognitionState = (order?: Order) => {
  const { rxRecognitionData } = order || {}
  const rxData = rxRecognitionData?.[0]?.data?.data

  const handler = rxRecognitionData?.[0]?.handler
  const lambdaData = handler === 'LAMBDA' ? rxData : undefined
  const rxPhysicianData = rxData?.clinical_details
  const rxPatientData = rxData?.demographics
  const rxContactData = rxData?.contact
  const rxPhysicianResult = rxRecognitionData?.[0]?.verificationResult?.physician
  const rxPatientResult = rxRecognitionData?.[0]?.verificationResult?.patient?.data

  const patientFormMarkup = useMemo(() => {
    if (!rxPatientResult && order && rxData) {
      const patientData = getPatientData(rxData)
      return orderPatientFormCss(patientData, order.patient)
    } else {
      return patientFormCss(rxPatientResult, handler)
    }
  }, [rxPatientResult, order, rxData, handler])

  return {
    rxPhysicianData,
    rxPhysicianResult,
    patientFormMarkup,
    rxPatientData,
    rxContactData,
    lambdaData,
  }
}
